import LocalforageStore from './LocalforageStore';

const Storage = {
  MEMORY_ROUTER: new LocalforageStore('memory-router'),
  APP_CONFIG: new LocalforageStore('app-config'),
  TABS_ROUTER: new LocalforageStore('tabs-router'),
};

export default Storage;
